const COMMON_ROUTE_PATHS = {
  commonAddCard: '/credit-card/add-card/:token',
  commonSelectCard: '/credit-card/select-card/:token',
  commonPay: '/:source/pay/:token',
  commonIdentityValidation: '/user/identity/validation/:token',
  commonProfile: '/user/profile/:token',
  commonNotFoundPage: '/not-found',
  authenticationFace: '/authentication/face/:token',
};

export default COMMON_ROUTE_PATHS;
